import { render, staticRenderFns } from "./addVillage.vue?vue&type=template&id=f4883db4&scoped=true&"
import script from "./addVillage.vue?vue&type=script&lang=js&"
export * from "./addVillage.vue?vue&type=script&lang=js&"
import style0 from "./addVillage.vue?vue&type=style&index=0&id=f4883db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4883db4",
  null
  
)

export default component.exports